import useScid from 'common/use-scid'

export const useUploadAPI = () => {
  const scid = useScid()
  return `/api/colleges/${scid}/integrations/crm/uploads`
}
export const useMappingAPI = () => {
  const scid = useScid()
  return `/api/colleges/${scid}/integrations/crm/map`
}

export const ERROR_MESSAGES = {
  badFormat: 'Sorry, bad file format. See our guides for more details.',
  notAuthorized: "Sorry, you're not authorized to upload.",
  fileSize: 'Sorry, that file is too large. Try breaking it up and uploading multiple times.',
  server: "Seems like our server isn't ready for your request. Please, try again later!",
  default: 'An error has occured...',
}

export const getErrorMessage = (response) => {
  switch (response.status) {
    case 400:
      return ERROR_MESSAGES.badFormat
    case 401:
      return ERROR_MESSAGES.notAuthorized
    case 413:
      return ERROR_MESSAGES.fileSize
    case 403:
    case 404:
    case 500:
      return ERROR_MESSAGES.server
    default:
      return ERROR_MESSAGES.default
  }
}
